module.exports = __webpack_public_path__ + "static/media/support-user-male.e8f076c1.png";